module.exports = __webpack_public_path__ + "img/img6.379fd817.png";